import Box from '@mui/material/Box'
import TablePagination from '@mui/material/TablePagination'
import { UsageLogInfo } from 'api/usageLog'
import PaginationActions from 'components/DocumentList/PaginationActions'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'

import UsageLogTable from './UsageLogTable'

function LabelDisplayedRows({ from, to, count }: { from: number; to: number; count: number }) {
  const totalText = count !== -1 ? count : to
  const text = `${totalText}件のうち${from}～${to}件までを表示`

  return (
    <Box component="span" display="flex" alignItems="center">
      {text}
    </Box>
  )
}

type Props = {
  rows: UsageLogInfo[]
  page: number
  totalCount: number
  rowsPerPage: number
  onPageChange: React.ComponentProps<typeof TablePagination>['onPageChange']
  onRowsPerPageChange: React.ComponentProps<typeof TablePagination>['onRowsPerPageChange']
}

const LogPaginatedTable = (props: Props) => {
  const { rows, page, totalCount, rowsPerPage, onPageChange, onRowsPerPageChange } = props

  return (
    <FullHeightFlexContainer>
      <UsageLogTable rows={rows} />
      <Box flexShrink="0">
        <TablePagination
          component="div"
          sx={{
            mb: 1,
          }}
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          labelRowsPerPage="最大表示件数:"
          labelDisplayedRows={LabelDisplayedRows}
          ActionsComponent={PaginationActions}
          rowsPerPageOptions={[10, 25, 50, 100]}
          data-testid="usage-log-table-pagination"
        />
      </Box>
    </FullHeightFlexContainer>
  )
}

export default LogPaginatedTable
